import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import ColTip from '@/components/Tip';
import PermWrapper from '@/components/PermWrapper';
import { toText } from '..';
import Modal from './Modal';

const subTitleStyle = { fontSize: 12, fontWeight: 400, marginTop: -10 };

function LimitPolicy({ data, commonProps }) {
  const [visible, setVisible] = useState(false);
  return (
    <Descriptions.Panel
      title='限流策略'
      bordered
      actions={
        <PermWrapper resource='kop:namespace:list:config'>
          <Button onClick={() => setVisible(true)} theme='default' variant='outline' size='small'>
            修改
          </Button>
        </PermWrapper>
      }
    >
      <Descriptions
        title={
          <ColTip
            content={
              <>
                <strong>生产限流</strong>
                <li>1、生产限流是对每个Topic的单个分区进行限制。</li>
                <li>2、默认为-1，代表禁用。</li>
                <li>3、限流存在一定的误差，不保证精确限流。</li>
                <p></p>
                <li>例如配置为1000/s，Topic分区为8，则每个分区生产流量限制为1000/s。</li>
              </>
            }
          >
            生产限流
          </ColTip>
        }
        style={{ padding: 0 }}
        titleStyle={subTitleStyle}
      >
        <Descriptions.Item
          label='吞吐'
          value={toText(data.publishThrottlingRateInByte, 'Byte/s')}
        />
        <Descriptions.Item label='速率' value={toText(data.publishThrottlingRateInMsg, '条/s')} />
        <Descriptions.Item label='统计间隔' value='1（秒）' />
      </Descriptions>
      <Descriptions
        title={
          <ColTip
            content={
              <>
                <strong>消费限流</strong>
                <li>1、消费限流是对每个Topic的单个分区进行限制。</li>
                <li>2、默认为-1，代表禁用。</li>
                <li>3、限流存在一定的误差，不保证精确限流。</li>
                <p></p>
                <li>例如配置为1000/s，Topic分区为8，则每个分区消费流量限制为1000/s。</li>
              </>
            }
          >
            消费限流
          </ColTip>
        }
        titleStyle={subTitleStyle}
      >
        <Descriptions.Item
          label='吞吐'
          value={toText(data.dispatchThrottlingRateBytes, 'Byte/s')}
        />
        <Descriptions.Item label='速率' value={toText(data.dispatchThrottlingRateMsg, '条/s')} />
        <Descriptions.Item
          label='统计间隔'
          value={toText(data.dispatchRatePeriodInSeconds, '秒')}
        />
      </Descriptions>
      <Descriptions
        title={
          <ColTip
            content={
              <>
                <strong>订阅速率</strong>
                <li>1、消费端建立链接并订阅的速率。</li>
                <li>2、默认为-1，代表禁用。</li>
              </>
            }
          >
            订阅速率
          </ColTip>
        }
        titleStyle={subTitleStyle}
      >
        <Descriptions.Item label='速率' value={toText(data.subscribeThrottlingRate, '条/s')} />
        <Descriptions.Item
          label='统计间隔'
          value={toText(data.subscribeRatePeriodInSecond, '秒')}
        />
      </Descriptions>
      <Modal
        visible={visible}
        detail={data}
        commonProps={commonProps}
        handleClose={() => setVisible(false)}
      />
    </Descriptions.Panel>
  );
}

export default connect((state) => ({
  data: state.kopNamespace.polices,
}))(LimitPolicy);
